
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
//  校验是否能认证普通机构或者服务机构
export const checkTimeSetting = params => request(BASE_URL + '/govEntIntermediary/checkSetting', { params })
// 校验企业认证状态（企业登录-服务机构）
export const checkStatus = params => request(BASE_URL + '/govEntIntermediary/checkStatus', { params })
// 获取审核记录 govExam/listRecords
export const listRecords = params => request(BASE_URL + '/govExam/listRecords', { params })
// 获取审核记录 /govEntCommonIntermediary/submitAuthen
export const submitAuthen = data => request.post(BASE_URL + '/govEntCommonIntermediary/submitAuthen', data)
// 获取审核记录 /govEntIntermediary/submitServerAuthen
export const submitServerAuthen = data => request.post(BASE_URL + '/govEntIntermediary/submitServerAuthen', data)
// 机构认证详情 /govEntIntermediary/govEntIntermediaryDetail
export const govEntIntermediaryDetail = params => request(BASE_URL + '/govEntIntermediary/govEntIntermediaryDetail', { params })
// 机构商品类型 /entGoods/entDictList
export const getGoodsType = params => request(BASE_URL + '/entGoods/entDictList', { params })
// 入驻承诺书模板下载 /govEntWhite/downEntWhiteModel
export const downEntWhiteModel = params => request(BASE_URL + '/govEntWhite/downEntWhiteModel', { params })

// 机构详情-替换上面的 govEntIntermediaryDetail -具体问承晓
export const govEntIntermediaryDetail2 = params => request(BASE_URL + '/govEntCommonIntermediary/govEntIntermediaryDetail2', { params })

// 服务机构详情-替换上面的 govEntIntermediaryDetail -具体问日鑫
export const govEntIntermediaryDetail3 = params => request(BASE_URL + '/govEntIntermediary/govEntIntermediaryDetail3', { params })

// 服务类型字典表
export const serviceTypeDic = params => request(BASE_URL + '/govEntIntermediary/serviceTypeDic', { params })
